import React from "react";

export default function TopLeftMenu({title, subtitle}) {
    return(
        <div style={{position:"absolute", left:"20px", top:"20px"}}>
            <h1 style={{margin:"0px 0px 5px", fontSize:"1.5rem", fontFamily:"FuturaNewDemi", fontWeight:"100"}}>{title}</h1>
            <div style={{width:"100%", height:"1px", backgroundColor:"rgba(0,0,0,0.25)"}} />
            <h2 style={{margin:"5px 0px", fontSize:"1rem", fontFamily:"FuturaNewBook", fontWeight:"100"}}>{subtitle}</h2>
        </div>
    );
}